import type { ComponentPropsWithoutRef } from 'react'
import classNames from 'classnames'

import styles from './styles/Paragraph.css'

export type ParagraphType = 'body' | 'small' | 'bodyLeft'

type ParagraphProps = ComponentPropsWithoutRef<'p'> & {
  type?: ParagraphType
  bold?: boolean
  italic?: boolean
  medium?: boolean
  light?: boolean
  left?: boolean
  center?: boolean
  small?: boolean
}

export const Paragraph = ({
  className = '',
  type = 'body',
  bold = false,
  italic = false,
  medium = false,
  light = false,
  left = false,
  center = false,
  small = false,
  children,
  ...rest
}: ParagraphProps) => {
  return (
    <p
      className={classNames(className, styles[type], {
        [styles.bold]: bold,
        [styles.italic]: italic,
        [styles.medium]: medium,
        [styles.small]: small,
        [styles.light]: light,
        [styles.center]: center
      })}
      {...rest}
    >
      {children}
    </p>
  )
}

export default Paragraph
